/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Creating_Mixdown_ExtendedInputs */



/**
* | output |
* | --- |
* | "Creating extended AD mixdown..." |
*
* @param {Audio_Description_Export_Status_Creating_Mixdown_ExtendedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_creating_mixdown_extended = /** @type {((inputs?: Audio_Description_Export_Status_Creating_Mixdown_ExtendedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Creating_Mixdown_ExtendedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Création du mixdown d'AD étendue...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erweiterter AD-Mixdown wird erstellt...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creazione di un mixdown AD esteso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создание расширенного AD-микса...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Creando una mezcla AD extendida...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建扩展的广告混音...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("拡張 AD ミックスダウンを作成しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विस्तारित AD मिक्सडाउन तैयार किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criando uma mixagem AD estendida...")
	return /** @type {LocalizedString} */ ("Creating extended AD mixdown...")
});